import classnames from 'classnames';

import './index.css';

const Button = _props => {
  const { children, active, highlight, disabled } = _props;
  const classNames = classnames('btn', {
    active: active,
    highlight: highlight,
    disabled: disabled,
  });
  const props = { ..._props };
  delete props.active;
  delete props.highlight;

  return (
    <button className={classNames} {...props}>
      {children}
    </button>
  );
};

export default Button;
